export default __webpack_public_path__ + "static/media/Jewel AP.fcf1dd76.jpg";